export default "__VITE_ASSET__DiQafI93__"